import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { APP_ICONS } from "../../assets";
import DashboardCard from "../../components/cards/DashboardCard";
import CustomBar from "../../components/customBar";
import Loader from "../../components/loader";
import NavigationDrawer from "../../components/navigationDrawer";
import { fetchCommissionHistory } from "../../services/Paymen";
import { constants } from "../../theme/Variables";
import AllCommissions from "./AllCommissions";

const CommissionsPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allCommissionedVendor, setAllCommissionedVendor] = useState([]);
  const [cardData, setCardData] = useState(null);

  let cartData = [
    {
      icon: APP_ICONS.cashBgIcon,
      value: cardData ? `$ ${cardData?.totalOrderAmount}` : "$ 0",
      title: "Total Sales",
      percentage: "00.00",
    },
    {
      icon: APP_ICONS.balanceBgIcon,
      value: cardData ? `$ ${cardData?.totalCommissionAmount}` : "$ 0",
      title: "Total BB Life Commission",
      percentage: "00.00",
    },
  ];

  useEffect(() => {
    handleFetchAllCommissionedVendor();
  }, []);

  const handleFetchAllCommissionedVendor = async () => {
    try {
      setIsLoading(true);
      const response = await fetchCommissionHistory();
      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        let data = response?.data?.data;
        setAllCommissionedVendor(data?.adminCommissions || []);
        setCardData(data?.cardData || []);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar("error", error?.message || "An error occurred");
    }
  };

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({ snackType: type, snackMessage: message });
  };
  return (
    <NavigationDrawer>
      <CustomBar title={"COMMISSIONS"} />
      {/* <Grid container spacing={2} mb={3}>
        {cartData.map((item, index) => {
          return (
            <Grid size={{ xs: 12, sm: 6 }}>
              <DashboardCard key={index} cardData={item} cardIndex={index} />
            </Grid>
          );
        })}
      </Grid> */}
      <AllCommissions data={allCommissionedVendor} />
      <Loader isloading={isLoading} />
    </NavigationDrawer>
  );
};

export default CommissionsPage;
